import { createAuthClient } from 'better-auth/react';

// In dev and prod the frontend talks to the backend through a same-origin
// `/api/*` path: dev uses Vite's proxy (vite.config.ts), prod uses Vercel
// rewrites (vercel.json). VITE_API_URL only kicks in if you explicitly want
// to bypass the proxy and hit a different origin.
const baseURL =
  import.meta.env.VITE_API_URL ||
  (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000');

export const authClient = createAuthClient({
  baseURL,
  fetchOptions: {
    credentials: 'include',
  },
});

export type Session = typeof authClient.$Infer.Session;
